var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.02 1H1.02002C1.02164 3.05633 1.65715 5.06217 2.83998 6.74426C4.02281 8.42635 5.69545 9.7029 7.63002 10.4C8.09933 10.5812 8.5021 10.9015 8.78445 11.3179C9.06681 11.7343 9.21528 12.2269 9.21001 12.73V20.24L12.84 17.62V13.74C12.8285 12.987 13.0347 12.2467 13.4339 11.608C13.833 10.9694 14.4081 10.4597 15.09 10.14C16.8563 9.35299 18.3566 8.07073 19.4091 6.44852C20.4615 4.82631 21.0211 2.93372 21.02 1Z",
    stroke: "#50504F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMap);
export default __webpack_public_path__ + "static/media/FilterMap.7f063131180b8432d3cd9900fa04a1d2.svg";
export { ForwardRef as ReactComponent };